function mapParams(params) {
  const { ..._params } = params;
  _params.sort = JSON.stringify(_params.sort || []);
  _params.filter = JSON.stringify(_params.filter || []);

  return _params;
}


export let tabulatorDataCache = {};

export function clearTabulatorCache() {
  tabulatorDataCache = {};
}

export function deleteTabulatorCacheEntry(key) {
  delete tabulatorDataCache[key];
}

function ajaxRequestViaApiService(api) {
  return function (url, config, params) {

    const key = JSON.stringify(mapParams(params));
    if (tabulatorDataCache[key]) {
      return Promise.resolve(tabulatorDataCache[key]);
    } else {
      return new Promise(async (resolve, reject) => {
        try {
          const urlParams = new URLSearchParams(mapParams(params));
          const data = await api({
            url: `${url}?${urlParams.toString()}`,
            method: config.method
          })
          tabulatorDataCache[key] = data;

          resolve(data);
        } catch (e) {
          reject(e);
        }
      });
    }
  }
}

export default ajaxRequestViaApiService;
